import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      component: () => import("@/views/home/Home.vue")
    },

    {
      path: "/about",
      component: () => import("@/views/home/About.vue")
    },

    {
      path: "/news",
      component: () => import("@/views/home/News.vue")
    },

    {
      path: '/news-detail',
      name: "NewsDetail",
      component: () => import("@/views/home/NewsDetail.vue")
    },

  ],

  //解决列表滑动跳转新闻详情也会滑动的问题
  //Vue Router 的默认行为中，页面切换时不会自动滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果是点击“后退/前进”按钮，保留滚动位置
    if (savedPosition) {
      return savedPosition
    }
    // 默认：跳转新页面时滚动到顶部
    return { top: 0 }
  }
})

export default router